module.exports = __webpack_public_path__ + "img/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.5dcd3e55.webp";